import { useCore } from '@/composables/core/index.js'
import { clone, filter, is, __ } from 'ramda'
import moment from 'moment'

import {
  DEV_CONSOLE_TYPE_TEXT as TYPE_TEXT,
  DEV_CONSOLE_TYPE_ERROR as TYPE_ERROR,
  DEV_CONSOLE_TYPE_REQUEST as TYPE_REQUEST,
  DEV_CONSOLE_TYPE_ROUTE_CHANGE as TYPE_ROUTE_CHANGE,
} from '@/lib/consts.js'

export const BUFFER_SIZE = 100

const BUFFER = []

const isObject = is(Object, __)

const logEntry = (entry) => {
  const time = moment().format('HH:mm:ss')
  BUFFER.unshift({
    ...entry,
    time,
  })
  BUFFER.length = BUFFER_SIZE
}

const logText = (text, ...rest) => {
  logEntry({
    type: TYPE_TEXT,
    text,
    rest,
  })
}

const logError = (text, ...rest) => {
  logEntry({
    type: TYPE_ERROR,
    text,
    rest,
  })
}

const logRequest = ({ method, url, params }) => {
  logEntry({
    type: TYPE_REQUEST,
    method,
    url,
    params,
  })
}

const logRouteChange = (to, from) => {
  logEntry({
    type: TYPE_ROUTE_CHANGE,
    from: from.fullPath,
    to: to.fullPath,
  })
}

const toggleAppMode = () => {
  const { store } = useCore()
  const mode = (store.state.app.mode === 'production' ? 'development' : 'production')
  localStorage.setItem('app.mode', mode)
  window.location.reload()
}

const getStartUrl = () => {
  const { store } = useCore()
  return [
    window.location.origin,
    store.state.app.basePath,
    '/start.html',
  ].join('')
}

const getBuffer = () => {
  return clone(filter(isObject, BUFFER))
}

export const useDevConsole = () => {
  return {
    logText,
    logError,
    logRequest,
    logRouteChange,
    toggleAppMode,
    getBuffer,
    getStartUrl,
  }
}
